import Cookies from 'js-cookie';

const COACH_TOKEN = 'coach_token';

export default {
    token() {
        return Cookies.get(COACH_TOKEN);
    },
    loggedIn() {
        return !!this.token();
    },
    login(token) {
        Cookies.set(COACH_TOKEN, token, { expires: 30 });
    },
    logoff() {
        Cookies.remove(COACH_TOKEN);
        localStorage.clear();
    },
};



// WEBPACK FOOTER //
// ./src/auth.js